// Stripe PaymentElement appearance matched to the design system (.oir tokens:
// {colors.primary}, ink-body, danger; Rubik; rounded.lg). Shared by the
// Oireachtas checkout and the payment-request pay page.
export const stripeAppearance = {
  variables: {
    colorPrimary: "#68ad3f",
    colorText: "#424242",
    colorDanger: "#da1414",
    fontFamily: 'Rubik, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    borderRadius: "11px",
  },
};
